
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import charModule from '@store/modules/char';
import LikeBtn from '@/resource/components/common/LikeBtn.vue';
import CharStartHead from '@/resource/components/char/CharStartHead.vue';
import LikeBtnWrap from '../common/LikeBtnWrap.vue';

export default defineComponent({
  name: 'BattleList',
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Object,
      default: {},
    },
    hasData: {
      type: Boolean,
      default: false
    },
    fromRole: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useI18n();
    const store = useStore();
    !store.hasModule('char') && store.registerModule('char', charModule);
    let charMap = null;

    const generateCharMap = () => {
      if (charMap) return;
      charMap = new Map();
      const charList = store.state.char.charList;
      for (let i = 0, len = charList.length; i < len; i++) {
        charMap.set(charList[i].id, charList[i]);
      }
    };

    // 获取角色信息
    const getCharInfoById = (charId: string) => {
      generateCharMap();
      return charMap.get(charId);
    };

    // 找到position = 5 的拿出它的soulRingGroup去匹配文案，position = 5会有1个或0个
    // soulRingType = 7 || 8 || 9优先展示，优先级 7 > 8 > 9
    const getRingDetail = (originData: string) => {
      let ringDetail = '';
      try {
        const RINGS_DETAIL = JSON.parse(originData);
        const ringDetailItem = RINGS_DETAIL.find((item) => item.position == 5);
        if(!ringDetailItem) return ringDetail;
        if(ringDetailItem.soulRingType == 7 || ringDetailItem.soulRingType == 8 || ringDetailItem.soulRingType == 9) {
          ringDetail = t(String(ringDetailItem.soulRingType));
        } else {
          ringDetail = ringDetailItem.soulRingType == 2 && ringDetailItem.soulRingGroup ? t(String(ringDetailItem.soulRingGroup)) : '';
        }
      } catch (e) {
        console.error(e);
      }
      return ringDetail;
    };

    const getTanSanRing = (originData: string) => {
      let ringPos = ''; // 魂技
      let skillOne = '';
      let skillTwo = '';
      const ssr = ['37004', '37008', '37006']; // 是SSR的才显示

      try {
        const RINGS_DETAIL = JSON.parse(originData);
        const ringDetailItem3 = RINGS_DETAIL.find((item) => item.position == 3);
        const ringDetailItem4 = RINGS_DETAIL.find((item) => item.position == 4);
        if(ringDetailItem3 && ringDetailItem3.years && ssr.includes(String(ringDetailItem3.years))) {
          skillOne = ringDetailItem3.years;
        }
        if(ringDetailItem4 && ringDetailItem4.years && ssr.includes(String(ringDetailItem4.years))) {
          skillTwo = ringDetailItem4.years;
        }

        if(skillOne != '' && skillTwo != '') {
          // 两个都有
          skillOne = t(skillOne).substring(0, 2) + '、';
          skillTwo = t(skillTwo).substring(0, 2);
        } else if(skillOne != '' && skillTwo == '') {
          // 只有第一个
          skillOne = t(skillOne);
        } else if(skillOne == '' && skillTwo != ''){
          // 只有第二个
          skillTwo = t(skillTwo);
        } else {
          // 两个都没有
          skillOne = '';
          skillTwo = '';
        }
        ringPos = skillOne + skillTwo;
      } catch(e) {
        console.error(e);
      }

      return {
        ringPos
      }
    }

    const formatList = computed(() => {
      const newValue = [];
      const list = props.list;
      const keys = Object.keys(props.list);
      for (let i = 0, len = keys.length; i < len; i++) {
        const value = list[keys[i]];
        const decorateValue = value
          .map(item => {
            if (item.CARD_ID == '4033') {
              const { ringPos } = getTanSanRing(item.RINGS_DETAIL);
              item.RINGS_POS = ringPos;
            }
            item.ringDetail = getRingDetail(item.RINGS_DETAIL);
            item.charInfo = getCharInfoById(item.CARD_ID);
            // 过滤掉没有角色信息的数据
            return item.charInfo ? item : null;
          })
          .filter(item => item);
         newValue.push({
          value: decorateValue,
          key: keys[i],
        });
      }
      return newValue;
    });

    const getBattleListClassName = (num) => {
      const classNameMap = {
        '6': 'six',
        '7': 'seven',
        '8': 'eight',
        default: 'six',
      };
      return classNameMap[String(num)] || classNameMap.default;
    };

    return {
      formatList,
      getBattleListClassName,
    };
  },
  methods: {
    beforeEnter(dom) {
      dom.classList.add('list-enter', 'list-enter-active');
    },
    enter(dom, done) {
      let delay = dom.dataset.delay;
      setTimeout(function () {
        dom.classList.remove('list-enter');
        dom.classList.add('list-enter-to');
        const transitionend = window.ontransitionend
          ? 'transitionend'
          : 'webkitTransitionEnd';
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd);
          done();
        });
      }, delay);
    },
    afterEnter(dom) {
      dom.classList.remove('list-enter-to', 'list-enter-active');
    },
  },
  components: { LikeBtn, CharStartHead, LikeBtnWrap },
});
